/**
 * HistoryModal Component
 * 수수료 변경 히스토리 모달 - 테이블 스타일 (본사와 동일)
 */
import React from 'react';
import { formatCurrency } from '@/shared/utils/formatter';
import { CommissionHistoryItem } from '../lib/supplierFeeHelpers';

interface HistoryModalProps {
    show: boolean;
    riderName: string;
    historyData: CommissionHistoryItem[];
    onClose: () => void;
}

const HistoryModal: React.FC<HistoryModalProps> = ({
    show,
    riderName,
    historyData,
    onClose
}) => {
    if (!show) return null;

    /** 금액 단위 반환 */
    const getAmountUnit = (commissionType: string): string => {
        return commissionType.includes('정률') ? '%' : '원';
    };

    /** 배경 클릭 시 닫기 */
    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) onClose();
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                backdropFilter: 'blur(3px)'
            }}
            onClick={handleBackdropClick}
        >
            <style>
                {`
                    @keyframes modalFadeIn {
                        from {
                            opacity: 0;
                            transform: scale(0.9) translateY(-20px);
                        }
                        to {
                            opacity: 1;
                            transform: scale(1) translateY(0);
                        }
                    }
                    .history-modal-supplier {
                        animation: modalFadeIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
                    }
                    .history-table-supplier {
                        width: 100%;
                        border-collapse: separate;
                        border-spacing: 0;
                    }
                    .history-table-supplier thead {
                        background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
                        box-shadow: 0 2px 4px rgba(0,0,0,0.08);
                    }
                    .history-table-supplier th {
                        padding: 16px 18px;
                        text-align: center;
                        font-weight: 700;
                        font-size: 0.9rem;
                        color: #212529;
                        border-bottom: 3px solid #dee2e6;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        text-shadow: 0 1px 1px rgba(255,255,255,0.8);
                    }
                    .history-table-supplier td {
                        padding: 16px 18px;
                        text-align: center;
                        border-bottom: 1px solid #e9ecef;
                        font-size: 0.9rem;
                        background: #ffffff;
                    }
                    .history-table-supplier tbody tr {
                        transition: all 0.2s ease;
                    }
                    .history-table-supplier tbody tr:hover {
                        background: linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%) !important;
                        transform: translateX(3px);
                        box-shadow: -3px 0 8px rgba(0,0,0,0.08);
                    }
                    .history-table-supplier tbody tr:last-child td {
                        border-bottom: none;
                    }
                    .period-badge-supplier {
                        display: inline-block;
                        padding: 8px 16px;
                        border-radius: 20px;
                        font-weight: 700;
                        font-size: 0.85rem;
                        box-shadow: 0 2px 6px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.3);
                        border: 1px solid rgba(255,255,255,0.3);
                        text-shadow: 0 1px 2px rgba(0,0,0,0.1);
                    }
                    .period-type-supplier {
                        background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
                        color: #ffffff;
                    }
                    .amount-cell-supplier {
                        font-weight: 700;
                        font-size: 1.05rem;
                        color: #2e7d32;
                        text-shadow: 0 1px 1px rgba(46, 125, 50, 0.1);
                    }
                    .close-button-supplier:hover {
                        background-color: #e9ecef;
                        transform: rotate(90deg);
                    }
                    .close-button-supplier {
                        transition: all 0.3s ease;
                    }
                    .footer-close-btn-supplier {
                        transition: all 0.2s ease;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    }
                    .footer-close-btn-supplier:hover {
                        background-color: #5a6268 !important;
                        transform: translateY(-1px);
                        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
                    }
                `}
            </style>
            <div
                className="history-modal-supplier"
                style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    width: '90%',
                    maxWidth: '900px',
                    maxHeight: '85vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0,0,0,0.05)',
                    overflow: 'hidden'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* 헤더 */}
                <div
                    style={{
                        padding: '24px 28px',
                        borderBottom: '1px solid #dee2e6',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                    }}
                >
                    <div>
                        <h3 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 700, color: '#ffffff', textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                            <i className="fas fa-history" style={{ marginRight: '12px' }}></i>
                            라이더 수수료 변경 이력
                        </h3>
                        <p style={{ margin: '8px 0 0 0', fontSize: '0.95rem', color: 'rgba(255,255,255,0.9)', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                            {riderName}
                        </p>
                    </div>
                    <button
                        className="close-button-supplier"
                        onClick={onClose}
                        style={{
                            background: 'rgba(255,255,255,0.2)',
                            border: '1px solid rgba(255,255,255,0.3)',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            color: '#ffffff',
                            padding: '8px 12px',
                            borderRadius: '8px',
                            backdropFilter: 'blur(10px)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                        }}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                {/* 본문 */}
                <div
                    style={{
                        padding: '0',
                        flex: 1,
                        overflowY: 'auto',
                        background: 'linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)'
                    }}
                >
                    {historyData.length === 0 ? (
                        <div
                            style={{
                                textAlign: 'center',
                                padding: '80px 24px',
                                color: '#868e96'
                            }}
                        >
                            <i className="fas fa-inbox" style={{ fontSize: '3.5rem', marginBottom: '20px', opacity: 0.3 }}></i>
                            <div style={{ fontSize: '1.1rem', fontWeight: 500, marginBottom: '8px', color: '#495057' }}>
                                변경 이력이 없습니다
                            </div>
                            <div style={{ fontSize: '0.9rem' }}>
                                수수료가 변경되면 이곳에 기록됩니다
                            </div>
                        </div>
                    ) : (
                        <table className="history-table-supplier">
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>적용일자</th>
                                    <th style={{ width: '25%' }}>수수료 유형</th>
                                    <th style={{ width: '20%' }}>금액</th>
                                    <th style={{ width: '20%' }}>수정자</th>
                                    <th style={{ width: '15%' }}>등록일시</th>
                                </tr>
                            </thead>
                            <tbody>
                                {historyData.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ fontWeight: 600 }}>{item.applyDate}</td>
                                        <td>
                                            <span className="period-badge-supplier period-type-supplier">
                                                {item.commissionType}
                                            </span>
                                        </td>
                                        <td className="amount-cell-supplier">
                                            {formatCurrency(item.amount.toString())}{getAmountUnit(item.commissionType)}
                                        </td>
                                        <td style={{ color: '#6c757d' }}>
                                            <i className="fas fa-user-circle" style={{ marginRight: '6px', color: '#adb5bd' }}></i>
                                            {item.modifier}
                                        </td>
                                        <td style={{ color: '#868e96', fontSize: '0.85rem' }}>
                                            {item.insDate ?? '-'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                {/* 푸터 */}
                <div
                    style={{
                        padding: '18px 28px',
                        borderTop: '1px solid #dee2e6',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: 'linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)',
                        boxShadow: '0 -2px 10px rgba(0,0,0,0.05)'
                    }}
                >
                    <div style={{ fontSize: '0.9rem', color: '#6c757d', fontWeight: 500 }}>
                        <i className="fas fa-info-circle" style={{ marginRight: '6px', color: '#667eea' }}></i>
                        총 <strong style={{ color: '#495057', fontSize: '1rem' }}>{historyData.length}</strong>건의 변경 이력
                    </div>
                    <button
                        className="footer-close-btn-supplier"
                        onClick={onClose}
                        style={{
                            padding: '10px 24px',
                            backgroundColor: '#6c757d',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: 600,
                            fontSize: '0.95rem'
                        }}
                    >
                        <i className="fas fa-times" style={{ marginRight: '8px' }}></i>
                        닫기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HistoryModal;
